import React from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { PageTitle } from '../../presentation-components/display-elements-components/page-title'
import { Emissions } from '../../presentation-components/emissons-components/overview/emissions'

export const DashboardScopeEmissionsPage = () => {
  const { scope } = useParams<{ scope: string }>()

  return (
    <PageOuterContainer>
      <Box sx={{ mb: 4 }}>
        <PageTitle title={`Scope ${scope} Emissions`} />
      </Box>
      <Emissions
        includeDelete={true}
        includeEdit={true}
        queryString={`scope=${scope}`}
        backLink='/dashboard'
        backText='Back to Dashboard'
      />
    </PageOuterContainer>
  )
}
